import { headers } from '@/_services/headers'
import { encrypt, decrypt } from '../../_services/encryption';
const state = {
    cardTypes: [],
    allBranches: [],
    locationBranches: [],
    deliveryOptions: [],
    requestFee: [],
    card: [],
    serviceRequest: [],
    singleServiceRequest: {}
};
const mutations = {
    // set the card types
    SET_CARD_TYPES(state, cardTypes) {
        state.cardTypes = cardTypes;
    },
    // set the branches
    SET_BRANCHES(state, branches) {
        state.allBranches = branches;
    },
    // set location branches
    SET_LOCATION_BRANCHES(state, locationBranches) {
        state.locationBranches = locationBranches;
    },
    // set delivery options
    SET_DELIVERY_OPTIONS(state, deliveryOptions) {
        state.deliveryOptions = deliveryOptions;
    },
    // set request fee
    SET_REQUEST_FEE(state, requestFee) {
        state.requestFee = requestFee;
    },
    // set card request
    SET_CARD(state, card) {
        state.card = card;
    },
    // set service request
    SET_SERVICE_REQUEST(state, serviceRequest) {
        state.serviceRequest = serviceRequest;
    },
    SET_SINGLE_SERVICE_REQUEST(state, singleServiceRequest) {
        state.singleServiceRequest = singleServiceRequest;
    }
};
const actions = {
    // get card types
    async getCardTypes({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Enum/getCardType`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_CARD_TYPES', userParseData);
            }
        }
    },
    // get all branches
    async getAllBranches({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Request/getAllBranches`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_BRANCHES', userParseData);
            }
        }
    },
    // get location branches
    async getLocationBranches({ commit }, location) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Request/getAvailableBranches/${location}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_LOCATION_BRANCHES', userParseData);
            }
        }
    },
    // get delivery options
    async getDeliveryOptions({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Enum/getDeliveryOption`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_DELIVERY_OPTIONS', userParseData);
            }
        }
    },
    // card request 
    async cardRequest({ }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Request/cardRequest`, encryptedData, { headers });
            return response;
        }
    },
    // cheque request
    async chequeRequest({ }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Request/chequeRequest`, encryptedData, { headers });
            return response;
        }
    },
    // get request fee
    async getRequestFee({ commit }, payload) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Request/serviceRequest/requestFee?requestType=${payload}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_REQUEST_FEE', userParseData);
            }
        }
    },
    // token request
    async tokenRequest({ }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Request/tokenRequest`, encryptedData, { headers });
            return response;
        }
    },
    // stop cheque request
    async stopCheque({ }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Request/chequeRequest/stopCheque`, encryptedData, { headers });
            return response;
        }
    },
    // account update request
    async accountUpdate({ }, payload) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            headers.Accept = 'multipart/form-data'
            const response = await this._vm.$http.post(`/Request/accountUpdateRequest`, payload, { headers });
            return response;
        }
    },
    // cash withdrawal request
    async cashWithdrawal({ }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Request/cashWithdrawalRequest`, encryptedData, { headers });
            return response;
        }
    },
    // account statement request
    async requestAccountStatement({ }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Account/ListAccountStatement`, encryptedData, { headers });
            return response;
        }
    },
    // account statement request
    async downloadAccountStatement({ }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Accept = 'application/pdf',
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Account/DownloadAccountStatement`, encryptedData, { responseType: 'arraybuffer', headers });
            return response;
        }
    },
    // get card request
    async getCards({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Request/Cards`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_CARD', userParseData);
            }
        }
    },
    // create complaint
    async createComplaint({ }, { data }) {
        const encryptedData = encrypt(data);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Complaints/Create`, encryptedData, { headers });
            return response;
        }
    },
    // card request
    async getCardRequest({ }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Request/cardRequests`, encryptedData, { headers });
            return response;
        }
    },
    // get service request
    async getServiceRequest({ commit }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Request/serviceRequests`, encryptedData, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_SERVICE_REQUEST', userParseData.requests);
            }
            return response;
        }
    },
    // get service request by id
    async getServiceRequestById({ commit }, id) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Request/serviceRequest/${id}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_SINGLE_SERVICE_REQUEST', JSON.parse(userParseData.requestDetails));
            }
            return response;
        }
    }

};
const getters = {
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};